import { useSelector } from "react-redux";
import { Typography, Box } from "@mui/material";
import type { RootState } from "../../../../../store/Index";
import LinkIcon from "@mui/icons-material/Link";
import Link from "@mui/material/Link";
import PropTypes from "prop-types";

const DeceasedDetail: React.FC<{
  detailHeader: string;
  detailValue: string;
  hasLink: boolean;
  url: string;
  headerIcon?: React.ReactNode; // new optional prop
}> = ({ detailHeader, detailValue, hasLink, url, headerIcon }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Box sx={{ mb: 1 }}>
      {/* Header with optional icon */}
      <Box display="flex" alignItems="center" gap={1} mb={0.5}>
        {headerIcon && <Box>{headerIcon}</Box>}
        <Typography
          variant="body1"
          sx={{
            fontSize: "14px",
            fontWeight: "medium",
            textTransform: "capitalize",
            color: reduxTheme.secondary_colors[200],
          }}
        >
          {detailHeader}
        </Typography>
      </Box>

      {/* Value */}
      {!hasLink ? (
        <Typography
          variant="body1"
          sx={{
            fontSize: "14px",
            fontWeight: "medium",
            textTransform: "capitalize",
          }}
        >
          {detailValue}
        </Typography>
      ) : (
        <Link href={url} display={"flex"} gap={1} alignItems="center" fontSize="14px">
          <LinkIcon />
          {detailValue}
        </Link>
      )}
    </Box>
  );
};

DeceasedDetail.propTypes = {
  detailHeader: PropTypes.string.isRequired,
  detailValue: PropTypes.string.isRequired,
  hasLink: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  headerIcon: PropTypes.node,
};

export default DeceasedDetail;
